import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import Notifications from "vue-notification";
import "vue-loading-overlay/dist/vue-loading.min.css";
import axios from 'axios';
import {
  faTimes,
  faSave,
  faCaretRight,
  faCaretDown,
  faTrashAlt,
  faPen,
  faUpload
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import jsonData from "../public/static/json/record.json";

library.add(
  faTimes,
  faSave,
  faCaretRight,
  faCaretDown,
  faTrashAlt,
  faPen,
  faUpload
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(Notifications);
let vuetify = new Vuetify({
  icons: {
    iconfont: "mdi" // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
  },
  options: {
    customProperties: true
  }
});

router.beforeEach(async (to, from, next) => {
  if (to.name === "login"){
    next();
  } else {
    if (store.state.record === null) {
      store.state.record = jsonData;
    }

    try {
      let user = await store.getters.user;
      if (!user || !user.permission) {
        let getUser = await store.dispatch("getUser");
        let sessionUser = getUser.data.result;
        await store.dispatch("setUser", sessionUser);
      }

      if (!axios.defaults.headers.post["X-CSRF-Token"] || axios.defaults.headers.post["X-CSRF-Token"] === "") {
        //axios.defaults.withCredentials = true;
        try {
          let token = await axios.get(store.state.host + "api/v1/csrfToken");
          axios.defaults.headers.post["X-CSRF-Token"] = token.data._csrf;
          axios.defaults.headers.delete["X-CSRF-Token"] = token.data._csrf;
          axios.defaults.headers.put["X-CSRF-Token"] = token.data._csrf;
        }
        catch (err) {
          console.log(err, 'error');
        }
      }
      store.state.editing = false;
      if (to.name === "edit" || to.name === "socioeconomic") {
        let editReport = await store.dispatch("getSingleReport", to.params.id);
        store.state.editing = true;
        store.dispatch("setRecord", editReport.data.result[0]);
      }
      next();
    } catch (err) {
      console.log("Usuario no autenticado");
      /*
      store.commit("setShowNotification", {
        type: "error",
        title: "ERROR",
        text: "El usuario no esta autenticado"
      });
      */
      next("/login");
    }
  }
});

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
